var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityOutlinedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Visibility",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    width: 22,
    height: 15,
    fill: "#333"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#334856",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1768",
    "data-name": "Groupe 1768",
    transform: "translate(1 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1767",
    "data-name": "Groupe 1767",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_411",
    "data-name": "Trac\\xE9 411",
    d: "M11,2a9.77,9.77,0,0,1,8.82,5.5,9.822,9.822,0,0,1-17.64,0A9.77,9.77,0,0,1,11,2m0-2A11.827,11.827,0,0,0,0,7.5a11.817,11.817,0,0,0,22,0A11.827,11.827,0,0,0,11,0m0,5A2.5,2.5,0,1,1,8.5,7.5,2.5,2.5,0,0,1,11,5m0-2a4.5,4.5,0,1,0,4.5,4.5A4.507,4.507,0,0,0,11,3",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOutlinedWhite);
export default __webpack_public_path__ + "static/media/VisibilityOutlinedWhite.c30ec602c99db003f0d7449b59711b18.svg";
export { ForwardRef as ReactComponent };